import { render, staticRenderFns } from "./GroupFiles.vue?vue&type=template&id=0934f667&lang=pug"
import script from "./GroupFiles.vue?vue&type=script&lang=js"
export * from "./GroupFiles.vue?vue&type=script&lang=js"
import style0 from "./GroupFiles.vue?vue&type=style&index=0&id=0934f667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports